import { LoadingSpinner } from '@/components/Generic'
import { observer } from 'mobx-react'
import { useContext, useEffect } from 'react'
import { StoreContext } from '@/store/Root.store'
import { MediaPermissionsChecker } from '@/components/MediaPermissionsChecker/MediaPermissionsChecker'
import { VideoIdAfterCancelPopup } from '@/components/VideoIdAfterCancelPopup/VideoIdAfterCancelPopup'
import { useVideoId } from '@/hooks/useVideoId/useVideoId'
import { axiosInstance } from '@/methods/axiosConfig'
import { devLog } from '@/methods/devLog'
import { callComplete } from '@/hooks/useVideoId/methods'
import { API_URL } from '@/constants/apiUrl'

export const VideoIdForStandardSignaturePage = observer(() => {
  const store = useContext(StoreContext)
  const { userAgent } = store.AppState
  const { isMobile } = store.AppState
  const { videoIdPage: trans } = store.TranslationsState.translations
  const { browser } = userAgent

  const onCompleted = async () => {
    await callComplete()

    try {
      await axiosInstance.post(
        `${API_URL}/electronic-id/receive-status-from-client`,
        { result: 'complete' },
        { withCredentials: true }
      )
    } catch (e) {
      devLog(e)
    }

    store.ScenarioState.nextPage()
  }

  const {
    afterClosePopupVisible,
    isPermissionCheckSuccessful,
    setIsPermissionCheckSuccessful,
    handleClosePopup,
    shouldHideEidv,
  } = useVideoId({ onCompleted })

  useEffect(() => {
    if (isPermissionCheckSuccessful && browser === 'firefox') {
      document.body.classList.add('hide-video-id-modal')
    }

    return () => {
      document.body.classList.remove('hide-video-id-modal')
    }
  }, [])

  const renderVideoId = () =>
    isPermissionCheckSuccessful ? (
      <div className="themed-eidv-wrapper">
        <div id="video" />
      </div>
    ) : (
      <MediaPermissionsChecker onPermissionCheckEnd={setIsPermissionCheckSuccessful} />
    )

  if (shouldHideEidv) {
    return (
      <div className="page-container mobile-m-10">
        <LoadingSpinner />
      </div>
    )
  }

  if (isMobile) {
    return (
      <>
        <VideoIdAfterCancelPopup
          title={trans.feedbackPopupTitle}
          thankYouForYourFeedback={trans.thankYouForYourFeedback}
          sendButtonText={trans.send}
          cancelButtonText={trans.close}
          visibility={afterClosePopupVisible}
          handleVisibility={handleClosePopup}
        />
        {renderVideoId()}
      </>
    )
  }

  return (
    <div className="page-container w-1000 mobile-m-0">
      <VideoIdAfterCancelPopup
        title={trans.feedbackPopupTitle}
        thankYouForYourFeedback={trans.thankYouForYourFeedback}
        sendButtonText={trans.send}
        cancelButtonText={trans.close}
        visibility={afterClosePopupVisible}
        handleVisibility={handleClosePopup}
      />
      {renderVideoId()}
    </div>
  )
})
